import { render, staticRenderFns } from "./ForceBuyForm.vue?vue&type=template&id=c760227c&"
import script from "./ForceBuyForm.vue?vue&type=script&lang=ts&"
export * from "./ForceBuyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports